// Dawn's product info column gets a scroll-reveal animation that leaves a
// lingering `transform` on it once finished, which makes it a containing
// block for `position: fixed` descendants. That traps the drawer inside the
// info column instead of covering the full viewport. Move it to <body>,
// matching how Dawn's own pickup-availability.js relocates this same
// component, so `position: fixed` measures against the real viewport.
const storePopupDrawer = document.querySelector('pickup-availability-drawer');
if (storePopupDrawer) {
  if (storePopupDrawer.parentElement !== document.body) {
    document.body.appendChild(storePopupDrawer);
  }

  // The overlay ships nested inside the drawer markup, but the drawer's own
  // `position: fixed` + `transform` make it the containing block for fixed
  // descendants, which would confine the overlay to the drawer's box instead
  // of the full viewport. Move it to a direct sibling of the drawer under
  // <body> so `position: fixed` measures against the real viewport, and its
  // visibility can be driven purely by CSS off the drawer's `[open]` state
  // via `pickup-availability-drawer[open] ~ .store-popup-overlay`.
  const overlay = storePopupDrawer.querySelector('.store-popup-overlay');
  if (overlay) storePopupDrawer.after(overlay);
}

document.querySelectorAll('[data-store-popup-open]').forEach((trigger) => {
  trigger.addEventListener('click', () => {
    const drawer = document.querySelector('pickup-availability-drawer');
    if (!drawer || typeof drawer.show !== 'function') return;

    // Deferred so the click doesn't immediately bubble into the drawer's
    // own "click outside to close" body listener, which it attaches as
    // part of show() during this same event.
    setTimeout(() => drawer.show(trigger), 0);
  });
});

class StorePopupInventory {
  constructor() {
    this.storeItems = document.querySelectorAll(
      '.store-item[data-product-id][data-variant-id][data-location-id]'
    );

    if (!this.storeItems.length) {
      return;
    }

    this.loadInventory();
  }


  async loadInventory() {
    const requests = Array.from(
      this.storeItems
    ).map((storeItem) => {
      return this.fetchInventory(storeItem);
    });

    await Promise.allSettled(requests);
  }


  async fetchInventory(storeItem) {
    const productId =
      storeItem.dataset.productId;

    const variantId =
      storeItem.dataset.variantId;

    const locationId =
      storeItem.dataset.locationId;

    if (
      !productId ||
      !variantId ||
      !locationId
    ) {
      console.warn(
        'Missing inventory parameters:',
        {
          productId,
          variantId,
          locationId
        }
      );

      return;
    }

    try {
      const response = await fetch(
        'https://appbit-staging.binaryic.in/api/v1/shopify/inventory',
        {
          method: 'POST',

          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',

            'X-Store-Name':
              'al-futtaim-watches-jewellery',

            'X-Store-Token':
              'o6CorYslOzJAwoGSnYMRe6KYV3km2wErvBzU8d7t1cU8XjmlhfrrjV6xPX9Z'
          },

          body: JSON.stringify({
            product_id: Number(productId),
            variant_id: Number(variantId),
            location_id: Number(locationId)
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          `Inventory API returned ${response.status}`
        );
      }

      const data =
        await response.json();

      console.log(
        'Inventory response:',
        data
      );

      this.updateStock(
        storeItem,
        data
      );

    } catch (error) {
      console.error(
        'Failed to fetch store inventory:',
        error
      );
    }
  }

  getMessages() {
    const language = document.documentElement.lang
      ?.toLowerCase()
      .split('-')[0];

    if (language === 'ar') {
      return {
        outOfStock: 'غير متوفر',
        inStock: 'متوفر',
        onlyInStock: (quantity) => `متبقي ${quantity} فقط في المخزون`
      };
    }

    return {
      outOfStock: 'Out of Stock',
      inStock: 'In Stock',
      onlyInStock: (quantity) => `Only ${quantity} in stock`
    };
  }

  updateStock(storeItem, data) {

    const messages = this.getMessages();

    const variantId = String(
      storeItem.dataset.variantId
    );

    const locationId = String(
      storeItem.dataset.locationId
    );

    const stockMessage =
      storeItem.querySelector(
        '[data-stock-message]'
      );

    const stockText =
      storeItem.querySelector(
        '[data-stock-text]'
      );

    if (
      !stockMessage ||
      !stockText
    ) {
      return;
    }

    const variant =
      data?.data?.variants?.find(
        (item) =>
          String(item.variant_id) ===
          variantId
      );

    if (!variant) {
      console.warn(
        'Inventory variant not found:',
        variantId
      );

      return;
    }

    const location =
      variant.locations?.find(
        (item) =>
          String(item.location_id) ===
          locationId
      );

    if (!location) {
      console.warn(
        'Inventory location not found:',
        {
          variantId,
          locationId
        }
      );

      return;
    }

    const quantity = Number(
      location.available_quantity
    );

    const threshold = Number(
      storeItem.dataset.lowStockThreshold ||
      5
    );

    console.log(
      'Store inventory:',
      {
        variantId,
        locationId,
        quantity,
        threshold
      }
    );

    stockMessage.classList.remove(
      'stock-message--available',
      'stock-message--low',
      'stock-message--unavailable'
    );

    if (quantity <= 0) {
      stockMessage.classList.add(
        'stock-message--unavailable'
      );

      stockText.textContent = messages.outOfStock;

      return;
    }

    if (quantity <= threshold) {
      stockMessage.classList.add(
        'stock-message--low'
      );

      stockText.textContent = messages.onlyInStock(quantity);

      return;
    }

    stockMessage.classList.add(
      'stock-message--available'
    );

    stockText.textContent = messages.inStock;
  }
}


new StorePopupInventory();
